import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as businessPaymentRunEmployeeDetailState from '../reducers';
import * as businessPaymentRunEmployeeDetailReducer from '../reducers/business-payment-run-detail-employee.reducer';

export const selectBusinessPaymentRunEmployeeDetail = createSelector(
  businessPaymentRunEmployeeDetailState.selectBusinessPaymentRunDetailEmployeeState,
  businessPaymentRunEmployeeDetailReducer.getBusinessPaymentRunDetailEmployees
);
